import type { App } from "vue";
import type { Router } from "vue-router";
import { visitTracker } from "../utils/visitTracker";

export function setupVisitTracking(app: App, router: Router): void {
  router.afterEach((to) => {
    visitTracker.trackPageView(to.path, to.meta?.title as string);
  });

  window.addEventListener("beforeunload", () => {
    visitTracker.trackDuration();
  });

  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      visitTracker.trackDuration();
    }
  });

  app.config.globalProperties.$visitTracker = visitTracker;
}

export { visitTracker } from "../utils/visitTracker";
